<template src="../templates/normal_fcont_96.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import CreativePrint from '../components/CreativePrint'
import CreatorProfileVosges from '../components/CreatorProfileVosges'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadCreative from '../components/AppDownloadCreative'
import AppDownloadiPrint from '../components/AppDownloadiPrint'

import { Carousel,Slide } from 'uiv'


export default {
  name: 'app',
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,FuncSearchGalleryQR,CreativePrint,
    CreatorProfileVosges,AppDownloadCreative,AppDownloadiPrint
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['96-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['96-2']}
    ]};
  }
};
</script>
<style >

</style>

